module.exports = __webpack_public_path__ + "img/pr-6.47435d64.png";